// Preserve the familiar icon positions from the current salon system.
const SALON_NAVIGATION_ORDER = ["dashboard", "calendar", "waitlist", "sales", "vouchers", "packages", "subscriptions", "discount-codes", "clients", "staff", "services", "resource", "products", "reports", "marketing"];

export const orderSystem1Modules = (modules) => {
  if (!Array.isArray(modules)) return [];
  const rank = route => {
    const index = SALON_NAVIGATION_ORDER.indexOf(route);
    return index >= 0 ? index : route === "settings" ? SALON_NAVIGATION_ORDER.length + 1 : SALON_NAVIGATION_ORDER.length;
  };
  return [...modules].sort((left, right) => rank(left?.route) - rank(right?.route));
};
